import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddOldCarFlow.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import StepIndicator from "./Common/StepIndicator";
import { Engine, Ruler, User, ShieldCheck } from "lucide-react";

export default function Specification(props) {
  const [engine, setEngine] = useState("");
  const [maxPower, setMaxPower] = useState("");
  const [maxTorque, setMaxTorque] = useState("");
  const [mileage, setMileage] = useState("");
  const [driveTrain, setDriveTrain] = useState("");

  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [wheelbase, setWheelbase] = useState("");
  const [groundClearance, setGroundClearance] = useState("");
  const [kerbWeight, setKerbWeight] = useState("");

  const [doors, setDoors] = useState("");
  const [seatingCapacity, setSeatingCapacity] = useState("");
  const [rows, setRows] = useState("");
  const [bootspace, setBootspace] = useState("");
  const [fuelTankCapacity, setFuelTankCapacity] = useState("");

  const [frontSuspension, setFrontSuspension] = useState("");
  const [rearSuspension, setRearSuspension] = useState("");
  const [frontbrakeType, setFrontBrakeType] = useState("");
  const [rearBrakeType, setRearBrakeType] = useState("");
  const [minTurningRadius, setMinTurningRadius] = useState("");
  const [steeringType, setSteeringType] = useState("");
  const [wheels, setWheels] = useState("");
  const [spareWheel, setSpareWheel] = useState("");
  const [frontTyres, setFrontTyres] = useState("");
  const [rearTyres, setRearTyres] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (props.client.oldCarId !== "") {
      props.addSpecification(
        props.login.token,
        props.login.user_id,
        props.client.oldCarId,
        engine,
        maxPower,
        maxTorque,
        mileage,
        driveTrain,
        length,
        width,
        height,
        wheelbase,
        groundClearance,
        kerbWeight,
        doors,
        seatingCapacity,
        rows,
        bootspace,
        fuelTankCapacity,
        frontSuspension,
        rearSuspension,
        frontbrakeType,
        rearBrakeType,
        minTurningRadius,
        steeringType,
        wheels,
        spareWheel,
        frontTyres,
        rearTyres
      );
      navigate("/feature");
    }
  };

  const renderInput = (label, value, setter, placeholder = "") => (
    <div className="flow-group">
      <label className="flow-label">{label}</label>
      <input className="flow-input" type="text" placeholder={placeholder || label} value={value} onChange={(e) => setter(e.target.value)} />
    </div>
  );

  return (
    <div className="old-car-flow-container">
      <StepIndicator currentStep={3} />

      <div className="old-car-flow-card">
        <h2 className="flow-title">Technical Specifications</h2>
        <p className="flow-subtitle">Detailed engineering and performance metrics</p>

        <form onSubmit={handleSubmit} className="flow-form">
          {/* Engine Section */}
          <div className="feature-category">
            <h3 className="category-title"><img src="/engine-icon.svg" alt="" width="20" /> Engine & Transmission</h3>
            <div className="flow-grid">
              {renderInput("Engine (cc)", engine, setEngine, "e.g. 1956")}
              {renderInput("Max Power (bhp@rpm)", maxPower, setMaxPower)}
              {renderInput("Max Torque (Nm@rpm)", maxTorque, setMaxTorque)}
              {renderInput("Mileage (ARAI)", mileage, setMileage)}
              <div className="flow-group">
                <label className="flow-label">Drive Train</label>
                <select className="flow-select" value={driveTrain} onChange={(e) => setDriveTrain(e.target.value)}>
                  <option value="">Select Drive Train</option>
                  <option value="fwd">FWD</option>
                  <option value="rwd">RWD</option>
                  <option value="awd">AWD</option>
                  <option value="4">4X4</option>
                  <option value="2">2WD</option>
                </select>
              </div>
            </div>
          </div>

          {/* Dimensions Section */}
          <div className="feature-category">
            <h3 className="category-title">Dimensions & Weight</h3>
            <div className="flow-grid">
              {renderInput("Length (mm)", length, setLength)}
              {renderInput("Width (mm)", width, setWidth)}
              {renderInput("Height (mm)", height, setHeight)}
              {renderInput("Wheelbase (mm)", wheelbase, setWheelbase)}
              {renderInput("Ground Clearance (mm)", groundClearance, setGroundClearance)}
              {renderInput("Kerb Weight (kg)", kerbWeight, setKerbWeight)}
            </div>
          </div>

          {/* Capacity Section */}
          <div className="feature-category">
            <h3 className="category-title">Capacity</h3>
            <div className="flow-grid">
              {renderInput("Doors", doors, setDoors)}
              {renderInput("Seating Capacity", seatingCapacity, setSeatingCapacity)}
              {renderInput("No of Rows", rows, setRows)}
              {renderInput("Bootspace (Litres)", bootspace, setBootspace)}
              {renderInput("Fuel Tank (Litres)", fuelTankCapacity, setFuelTankCapacity)}
            </div>
          </div>

          {/* Handling Section */}
          <div className="feature-category">
            <h3 className="category-title">Steering, Brakes & Tyres</h3>
            <div className="flow-grid">
              {renderInput("Front Suspension", frontSuspension, setFrontSuspension)}
              {renderInput("Rear Suspension", rearSuspension, setRearSuspension)}
              {renderInput("Front Brake Type", frontbrakeType, setFrontBrakeType)}
              {renderInput("Rear Brake Type", rearBrakeType, setRearBrakeType)}
              {renderInput("Steering Type", steeringType, setSteeringType)}
              {renderInput("Wheels", wheels, setWheels)}
              {renderInput("Front Tyres", frontTyres, setFrontTyres)}
              {renderInput("Rear Tyres", rearTyres, setRearTyres)}
            </div>
          </div>

          <div className="flow-actions">
            <button type="button" className="flow-btn-secondary" onClick={() => navigate(-1)}>Back</button>
            <button type="button" className="flow-btn-secondary" onClick={() => navigate("/feature")}>Skip</button>
            <button type="submit" className="flow-btn-primary">Next Step</button>
          </div>
        </form>
      </div>

      <LoaderCon />
      <Snackbar1
        open={props.snackbar.response_received}
        onClose={props.close_snack_bar}
        message={props.snackbar.message}
      />
    </div>
  );
}

